
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EntityAcreditacionEmpresa } from "./entity-acreditacion-empresa.model";
import { Observable, of } from "rxjs";
import { environment } from "projects/registro-personas-empresas/src/environments/environment";
import { catchError, map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class EntityAcreditacionEmpresaService {
  endpoint = 'acreditacionEmpresa';

  constructor(private http: HttpClient) { }

  getAll(): Observable<EntityAcreditacionEmpresa[]> {
    return this.http.get<EntityAcreditacionEmpresa[]>(`${environment.apiUrl}/${this.endpoint}/`)
      .pipe(
        map((items) => items),
        catchError(() => {
          return of([
            {
              id: 1,
              entidad_productiva_id: 13724,
              etapas_id: [1, 2, 3, 4],
              especies_certificable_id: [1803, 4924],
              manual_calidad_1: new File([], 'DatosDelaAcreditacion'),
            },
            {
              id: 2,
              entidad_productiva_id: 13724,
              etapas_id: [1, 4],
              especies_certificable_id: [4924],
              manual_calidad_1: new File([], 'DocumentoAlguno.pdf'),
              manual_calidad_2: new File([], 'DocumentoAlguno2.pdf'),
              manual_calidad_3: new File([], 'DocumentoAlguno3.pdf'),
            }
          ])
        })
      )
  }

  add(item: EntityAcreditacionEmpresa): Observable<EntityAcreditacionEmpresa> {
    return this.http.post<EntityAcreditacionEmpresa>(`${environment.apiUrl}/${this.endpoint}/`, item);
  }

  update(item: EntityAcreditacionEmpresa): Observable<EntityAcreditacionEmpresa> {
    return this.http.patch<EntityAcreditacionEmpresa>(`${environment.apiUrl}/${this.endpoint}/${item.id}/`, item);
  }
}
